export const fetchPosts = () =>
  fetch('https://youhelp.ru/blog/wp-json/wp/v2/posts?categories=5&per_page=3').then((response) => response.json());

export const fetchMedia = (id: number) => fetch(`https://youhelp.ru/blog/wp-json/wp/v2/media/${id}`).then((response) => response.json());
